import { Color } from './java/Color';
import { Graphics2D } from './java/Graphics2D';
import { Rectangle } from './java/Geom';
import { GameObject } from './GameObject';
import { Handler } from './Handler';
import { ID } from './ID';
import { TrailPool } from './TrailPool';
import { Game } from './Game';

export class BasicEnemy extends GameObject {
  private static readonly SIZE = 32;
  private static readonly R = 8;
  private static readonly FILL = new Color(235, 87, 87);
  private static readonly GLOW = new Color(235, 87, 87, 35);
  private static readonly TRAIL_COLOR = new Color(235, 87, 87);

  private handler: Handler;
  private trailTick = 0;
  private readonly boundsRect = new Rectangle();
  private hp = -1; // -1 = no HP (dodge mode)

  constructor(x: number, y: number, id: ID, handler: Handler) {
    super(x, y, id);
    this.handler = handler;
    this.velX = 5;
    this.velY = 5;
  }

  setCombatHp(hp: number): void { this.hp = hp; }

  override takeDamage(dmg: number): boolean {
    if (this.hp < 0) return false;
    this.hp -= dmg;
    if (this.hp <= 0) { this.die(); return true; }
    return true;
  }

  private die(): void {
    const half = Math.trunc(BasicEnemy.SIZE / 2);
    for (let i = 0; i < 6; i++) {
      const angle = Math.random() * Math.PI * 2;
      TrailPool.add(
        this.x + half + Math.cos(angle) * 8,
        this.y + half + Math.sin(angle) * 8,
        BasicEnemy.FILL, half, half, 0.05);
    }
    Game.addEnemyKilled();
    Game.addKillBonus(50);
    this.handler.removeObject(this);
  }

  getBounds(): Rectangle {
    this.boundsRect.x = Math.trunc(this.x);
    this.boundsRect.y = Math.trunc(this.y);
    this.boundsRect.width = BasicEnemy.SIZE;
    this.boundsRect.height = BasicEnemy.SIZE;
    return this.boundsRect;
  }

  tick(): void {
    const half = Math.trunc(BasicEnemy.SIZE / 2);
    this.x += this.velX;
    this.y += this.velY;
    if (this.y <= 0 || this.y >= Game.HEIGHT - BasicEnemy.SIZE) {
      Game.wallHit(this.x + half, this.y <= 0 ? 0 : Game.HEIGHT, this.y <= 0 ? 0 : 1, 235, 87, 87);
      this.velY *= -1;
    }
    if (this.x <= 0 || this.x >= Game.WIDTH - BasicEnemy.SIZE) {
      Game.wallHit(this.x <= 0 ? 0 : Game.WIDTH, this.y + half, this.x <= 0 ? 2 : 3, 235, 87, 87);
      this.velX *= -1;
    }
    if (++this.trailTick % 3 === 0)
      TrailPool.add(this.x, this.y, BasicEnemy.TRAIL_COLOR, BasicEnemy.SIZE, BasicEnemy.SIZE, 0.02);
  }

  render(g: Graphics2D): void {
    const g2 = g;
    const ix = Math.trunc(this.x), iy = Math.trunc(this.y);
    g2.setColor(BasicEnemy.GLOW);
    g2.fillRoundRect(ix - 4, iy - 4, BasicEnemy.SIZE + 8, BasicEnemy.SIZE + 8, BasicEnemy.R + 4, BasicEnemy.R + 4);
    g2.setColor(BasicEnemy.FILL);
    g2.fillRoundRect(ix, iy, BasicEnemy.SIZE, BasicEnemy.SIZE, BasicEnemy.R, BasicEnemy.R);
  }
}
